@if(isDisabled){
<app-loader></app-loader>
}
<div class="card">
    <div class="card-header">
        Staff Cost Center Mapping
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-6 px-1">
                <label>Branch <span class="text-danger">*</span></label>
                <ng-select name="Branch" placeholder="Select Branch" [items]="BranchLoad" bindLabel="BranchName"
                    bindValue="BranchMasterID" (change)="FillCombo('BranchStaffCostCenter');FillCombo('BranchStaffForPosting');" [(ngModel)]="BranchId" required>
                </ng-select>
                <div class="invalid-feedback">
                    Please select Branch
                </div>
            </div>
        </div>
        <div class="row m-1 mt-1">
            <div class="col-md-6 px-1">
                <label>Employee <span class="text-danger">*</span></label>
                <ng-select name="Employee" placeholder="Select Employee" [items]="EmployeesLoad" bindLabel="EmpCode" bindValue="EmpMasterID" [(ngModel)]="EmployeeId" required>
                </ng-select>
                <div class="invalid-feedback">
                    Please select Employee
                </div>
            </div>
        </div>
        <div class="row m-1 mt-1">
            <div class="col-md-7 px-1">
                <label>Cost Center <span class="text-danger">*</span></label>
                <ng-select name="CostCenter" placeholder="Select Cost Center" [items]="CostCenterLoad" bindLabel="Description"
                    bindValue="CostCentreCode" [(ngModel)]="CostCenterId" required>
                </ng-select>
                <div class="invalid-feedback">
                    Please select Cost Center
                </div>
            </div>
        </div>

    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" (click)="upload()" class="upload-btn"
                    [disabled]="isDisabled">
                    <i class="bi bi-upload" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Upload':'Loading...'}}
                </button>
            </div>
            <div class="col-auto">
                <button type="button" class="upload-btn" [disabled]="isDisabled" (click)="Save()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>